
export const deptMembers = (state) => {
  return state.deptMembers
}
export const dept = (state) => {
  return state.dept
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getMemberById = (state) => (id) => {
  return state.deptMembers.find(item => item.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  deptMembers,
  dept,
  total,
  offset,
  max,
  getMemberById,
  sort,
  order
}
